// @noflow
import CoolingSpinner from './cooling';
import DualSpinner from './dual-spinner';
import HeatingSpinner from './heating';
import PropTypes from 'prop-types';
import * as React from 'react';

const componentMap = {
    AUTO: { component: DualSpinner, mode: ['heat', 'cool'] },
    HEAT: { component: HeatingSpinner, mode: 'heat' },
    COOL: { component: CoolingSpinner, mode: 'cool' },
    default: { component: HeatingSpinner, mode: 'heat' }
};

const Component = ({ controlMode, className, ...props }) => {
    const { component: Comp, mode } = componentMap[controlMode] || componentMap.default;

    return (
        <div className={className}>
            <Comp mode={mode} {...props} />
        </div>
    );
};

Component.propTypes = {
    className: PropTypes.string,
    controlMode: PropTypes.string
};

export default Component;



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/dual-color-range/index.js